import jscAdd from 'ehogan-loader/jscmanager';

import BaseRegistrationFormView from 'registration/js/base/registration_form_view';

import ErrorBlock from 'registration/js/base/error_block';

import {
    bindLoginServerError,
} from 'registration/js/lib/validators';

import abTestWrapper from 'registration/js/lib/abtest_trigger_wrapper';

import template from 'registration/templates/new/form.html';

import Birthdate from './fields/birthdate';
import ErrorField from './fields/error';
import DescriptionField from './fields/description';
import BonusCode from './fields/bonus_code';
import LoginField from './fields/login';
import NameField from './fields/name';
import ParentalEmailField from './fields/parental_email';
import PasswordField from './fields/password';
import RepasswordField from './fields/repassword';
import CaptchaField from './fields/captcha';
import CountryCodeField from './fields/country_code';
import EulaField from './fields/eula';
import SubmitButton from './fields/submit';

import SuggestionDialogView from './suggestion_dialog_view';


jscAdd([
    ErrorBlock,
    DescriptionField,
    ErrorField,

    BonusCode,
    LoginField,
    NameField,
    PasswordField,
    RepasswordField,
    CaptchaField,
    CountryCodeField,
    EulaField,
    SubmitButton,

    Birthdate,
    ParentalEmailField,
]);

const NewBasicFormView = BaseRegistrationFormView.extend({
    template,
    SuggestionDialogView,
    afterInitialize() {
        BaseRegistrationFormView.prototype.afterInitialize.call(this);
        bindLoginServerError(this.$form, 'login');
        this.showCountryCodeConflictError();
    },
    getContext(context = {}) {
        context.powAllowed = this.model.powAllowed();
        return BaseRegistrationFormView.prototype.getContext.call(this, context);
    },
    onRegistrationSuccess: abTestWrapper(
        BaseRegistrationFormView.prototype.onRegistrationSuccess,
        '^.*registration success.*$'
    )
});


export default NewBasicFormView;
